import React, { useEffect, useState } from 'react';
import { AiFillCustomerService, AiOutlineBell, AiOutlineStock, AiOutlineUser } from 'react-icons/ai';
import { FaBars, FaChartBar, FaCogs, FaHandshake, FaUser, FaBell, FaList, FaCog, FaUsers, FaUpload, FaMoneyBill, FaSignOutAlt, FaBuilding, FaShoppingCart, FaCashRegister, FaUserSlash, FaReceipt } from 'react-icons/fa';
import { FaListCheck, FaUsersGear } from 'react-icons/fa6';
import { MdDashboard, MdEvent, MdPayments } from 'react-icons/md';
import { Outlet, useLocation, NavLink  } from 'react-router-dom';
import { useAuth } from '../context/auth-context';
import { toast } from 'react-toastify';
import axios from 'axios';
import { rootUrl } from '../helpers';
import { FcCustomerSupport, FcPlanner } from 'react-icons/fc';
import { BiReceipt } from 'react-icons/bi';
import { PiInvoice } from 'react-icons/pi';
import { CiBank, CiSettings } from 'react-icons/ci';
import { IoIosSwap } from 'react-icons/io';
import { GrProjects } from 'react-icons/gr';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function UserLayout() {

    const auth = useAuth();

    const [allData, setAllData] = useState([]) 
    const [transactions, setTransactions] = useState([]);


    const routes = [
      { path: '/', name: 'Dashboard', icon: <MdDashboard className="mr-2" /> },
      { path: '/products', name: 'Products', icon: <AiOutlineStock className="mr-2" /> },
      { path: '/sales', name: 'Sales', icon: <FaShoppingCart className="mr-2" /> },
      { path: '/cash', name: 'Cash', icon: <FaChartBar className="mr-2" />  },
    ];


    // const check = async () =>{
    //   try{
    //     const response = await axios.get(rootUrl(`/getNavRoles/${auth.user?.id}`))
    //     setRoutes([])
    //     setRoutes(prev=>[...prev, { path: '/', name: 'Dashboard', icon: <MdDashboard className="mr-2" /> }])
    //     routez.map((res)=>{
    //       if(response.data.data.find(a=>a.name == res.name)){
    //         setRoutes(prev=>[...prev, res])
    //       }
    //     })
          
    //   }catch(e){
    //     // window.location.href = "/"
    //   }
    // }


    const fetchData = async ()=>{
        try{
            const data = await axios.get(rootUrl(`/getProducts/${auth.user.shop}`))
            setAllData(data.data)
        }catch(e){
            toast.error(e?.message)
        }
    }


    useEffect(()=>{
      fetchData()
    }, [])

    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const location = useLocation();
    const currentUrl = location.pathname + location.search;
  
    const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
    };
  
    const signOut = () => {
      auth.logOut(()=>{
         window.location.href = "/"
      })
  
    }

return (
    <div className="flex bg-gray-200">
      {/* Sidebar */}
      <div
    className={`fixed bottom-0 top-0 w-1/5 text-lg bg-blue-950 text-white py-4 shadow-2xl transform transition-transform duration-300 ease-in-out ${
      isSidebarOpen ? "translate-x-0" : "-translate-x-full"
    } `}
  >
    <div className="flex justify-center">
      {/* <div className='bg-white rounded-full'> */}
      <img src="/logo.png" alt="Logo" className="mx-auto w-1/2" />
      {/* </div> */}
      
    </div>

    <hr className="my-5 bg-gray-300" />

    <div className="h-[90vh] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-200">
      <ul className="space-y-2">
        {routes.map((route) => (
          <li
            key={route.path}
            className={`rounded-l-3xl cursor-pointer py-2 ml-4 pl-3 flex items-center text-lg ${
              currentUrl === route.path
                ? "bg-gray-300 text-black"
                : ""
            }`}
          >
            <NavLink
              to={route.path}
              className="flex items-center w-full"
            >
              {route.icon} {route.name}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  </div>

      {/* Main Content */}
      <div
    className={`p-6 transition-all duration-300 ease-in-out w-full ${
      isSidebarOpen ? "lg:ml-[20%] lg:w-4/5" : "ml-0"
    }`}
    id="main-content"
  >
    <div className="bg-white rounded-lg shadow p-4 mb-4">
      <header className="flex justify-between items-center">
        <h1 className="text-xl font-semibold flex items-center">
          <button
            className="mr-2 text-gray-800 cursor-pointer"
            onClick={toggleSidebar}
          >
            <FaBars />
          </button>
          <span className='font-bold text-3xl'>{auth?.user?.shop?'Shop '+auth.user.shop :'Admin'}</span>
        </h1>
            <div className="flex items-center space-x-4">
              <a href="#" className="relative text-gray-800 flex items-center">
              <NavLink to={'/transactions'} className="relative inline-block m-2">
              <AiOutlineBell size={30} className="" />
              {transactions?.length > 0 && (
                <span className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                  {transactions?.length}
                </span>
              )}
            </NavLink>
                <AiOutlineUser size={30} className='m-2'/>
                
                <FaSignOutAlt onClick={signOut} title='logout' className='text-2xl'/>
              </a>
              
            </div>
          </header>
        </div>


 
      
    
      <div className='bg-gray-100 p-5 bg-white rounded-lg shadow-lg overflow-x-auto'>

        {
          allData.products === undefined?
          <div className="min-h-screen bg-gray-50 p-8">
        <div className="max-w-7xl mx-auto">
          <Skeleton count={6} height={100} className="mb-4" />
        </div>
        </div>
        :
      <Outlet context={{ allData, setAllData }}/>
        }
      
      </div>
              

        <div className="bg-white rounded-lg shadow p-2 mt-4">
          <footer className="text-center">
            &copy; {new Date().getFullYear()}. All rights reserved.
          </footer>
        </div>
      </div>
    </div>
  );

}